import * as React from 'react';
import PropTypes from "prop-types";
import {isMobile} from "react-device-detect";
// import 'moment/locale/nn';
// import 'moment/locale/en-gb';

// React DateRangePicker
import 'react-dates/initialize';
import { DateRangePicker as DatePicker } from 'react-dates';
import 'react-dates/lib/css/_datepicker.css';
import useAfterUpdateEffect from "../utils/useAfterUpdateEffect";
import {useTranslation} from "react-i18next";

function DateRangePicker(props) {
  const { t } = useTranslation('date_range_picker')
  const [dateFrom, setDateFrom] = React.useState(props.dateFrom);
  const [dateTo, setDateTo] = React.useState(props.dateTo);
  const [focused, setFocused] = React.useState(props.focused);

  useAfterUpdateEffect(() => {
    if(props.dateFrom !== dateFrom){
      setDateFrom(props.dateFrom)
    }
    if(props.dateTo !== dateTo){
      setDateTo(props.dateTo)
    }
  }, [props.dateFrom, props.dateTo])

  return (
    <DatePicker
      onClose={({ startDate, endDate }) => {
        if (props.onClose) {
          props.onClose({ startDate, endDate });
        } else {
          props.onDatesChange({ startDate, endDate });
        }
      }}
      minimumNights={0}
      displayFormat={props.displayFormat}
      startDatePlaceholderText={props.startDatePlaceholderText ?? t('start_date_placeholder')}
      endDatePlaceholderText={props.endDatePlaceholderText ?? t('end_date_placeholder')}
      numberOfMonths={props.numberOfMonths}
      showClearDates={props.showClearDates}
      isOutsideRange={() => false}
      startDate={dateFrom}
      startDateId="startDate"
      endDate={dateTo}
      endDateId="endDate"
      onDatesChange={({startDate, endDate}) => {
        setDateFrom(startDate);
        setDateTo(endDate);

        props.onDatesChange({
          startDate,
          endDate
        });
      }}
      focusedInput={focused}
      onFocusChange={focused => setFocused(focused)}
    />
  );
}

DateRangePicker.defaultProps = {
  displayFormat: 'YYYY-MM-DD',
  numberOfMonths: isMobile ? 1 : 2,
  showClearDates: true,
  focused: null,
};

DateRangePicker.propTypes = {
  showClearDates: PropTypes.bool,
  numberOfMonths: PropTypes.number,
  dateFrom: PropTypes.object,
  dateTo: PropTypes.object,
  displayFormat: PropTypes.string,
  startDatePlaceholderText: PropTypes.string,
  endDatePlaceholderText: PropTypes.string,
  onDatesChange: PropTypes.func.isRequired,
  focused: PropTypes.oneOf([null, 'startDate', 'endDate']),
  onClose: PropTypes.func,
};

export default DateRangePicker;
